export default __webpack_public_path__ + "locales/az/EmptyView.json?hash=191c49ca31da56ed7e31052df9c4730f";